import React, { ReactElement } from 'react';
import { Result, Paragraph, ResultVariants } from '@dexma/ui-components';
import i18n from 'asset/translation';
import AddFirstWidget from 'asset/images/addFirstWidget.svg';
import { StyledAddFirstWidgetResult } from 'adapter/in/dashboards/pages/EditDashboard/AddFirstWidgetResult/style';

const EmptyDashboardPage = (): ReactElement => (
    <Result
        variant={ResultVariants.DEFAULT}
        data-testid='empty-dashboard'
        title={i18n.t('dashboards.emptyDashboard.title')}
        iconElement={<AddFirstWidget />}
        content={
            <StyledAddFirstWidgetResult>
                <Paragraph className='content'>{i18n.t('dashboards.emptyDashboard.content')}</Paragraph>
                <Paragraph className='subcontent'>{i18n.t('dashboards.emptyDashboard.subcontent')}</Paragraph>
            </StyledAddFirstWidgetResult>
        }
    />
);

export default EmptyDashboardPage;
